import {SelectTaskTypeOption, SelectTaskTypeProps, SelectTaskTypeState} from "./@types"

export function getAllTaskTypes(props:SelectTaskTypeProps):string[] {
    const companyTaskTypes = gd.session.taskTypes.filterByCompany(gd.companyId)
    return props.taskTypesIds || _.map(companyTaskTypes.models, (tt:any) => tt.id)
}

export function getInitialState(props:SelectTaskTypeProps):SelectTaskTypeState {
    let allowedTaskTypes = []
    if (props.allowedTaskTypes) {
        allowedTaskTypes = props.allowedTaskTypes
    } else if (props.projectId) {
        allowedTaskTypes = gd.session.projects.get(props.projectId).getInheritedTaskTypes()
    }

    let value = null
    let values = []

    if (props.multiselect) {
        if (props.form && props.form.getValue(props.name)) {
            values = props.form.getValue(props.name)
        } else if (props.values) {
            values = props.values
        } else {
            values = []
        }
    } else {
        if (props.form && props.form.getValue(props.name)) {
            value = props.form.getValue(props.name)
        } else if (props.value) {
            value = props.value
        } else {
            value = allowedTaskTypes[0]
        }
    }

    return {
        showPopover: false,
        value: value,
        values: values,
        allowedTaskTypes: allowedTaskTypes
    }
}

// state changes caused by new props - empty object when nothing changed
export function getStateUpdateFromProps(nextProps:SelectTaskTypeProps, prevProps:SelectTaskTypeProps, state:SelectTaskTypeState) {
    const form = nextProps.form
    const updateState:Partial<SelectTaskTypeState> = {}

    if (nextProps.multiselect) {
        if (form) {
            const formValue = form.getValue(nextProps.name)
            if (formValue != state.values) {
                updateState.values = formValue
            }
            if (!nextProps.allowedTaskTypes && nextProps.projectId) {
                updateState.allowedTaskTypes = gd.session.projects.get(nextProps.projectId).getInheritedTaskTypes()
            }
        } else {
            if (typeof nextProps.values !== 'undefined' && nextProps.values !== state.values) {
                updateState.values = nextProps.values
            }
        }
    } else {
        if (form) {
            const formValue = form.getValue(nextProps.name)
            if (formValue != state.value) {
                updateState.value = formValue
            }
            if (!nextProps.allowedTaskTypes && nextProps.projectId) {
                updateState.allowedTaskTypes = gd.session.projects.get(nextProps.projectId).getInheritedTaskTypes()
            }

        } else {
            if (typeof nextProps.value !== 'undefined' && nextProps.value !== state.value) {
                updateState.value = nextProps.value
            }
        }
    }

    if (nextProps.projectId && nextProps.projectId!=prevProps.projectId) {
        updateState.allowedTaskTypes = gd.session.projects.get(nextProps.projectId).getInheritedTaskTypes()
    } else if (nextProps.allowedTaskTypes && nextProps.allowedTaskTypes !== state.allowedTaskTypes) {
        updateState.allowedTaskTypes = nextProps.allowedTaskTypes
    }

    return updateState
}

// 2 types of options: no-value, taskType
export function getTaskTypeOptions(allTaskTypes:string[], allowedTaskTypes:string[], canHaveNoValue:boolean) {
    const selectOptions:SelectTaskTypeOption[] = []

    if (canHaveNoValue) {
        selectOptions.push({
            type: 'no-value'
        })
    }

    _.map(allTaskTypes, ttId => {
        selectOptions.push({
            type    : 'task-type',
            disabled: !allowedTaskTypes.includes(ttId),
            taskType: gd.session.taskTypes.get(ttId),
        })
    })

    return selectOptions
}
